import { Injectable } from '@angular/core'
import { HttpService } from '@lla-platform/core/core-data-access'
import { DateService } from '@lla-platform/core/core-util'
import { Observable } from 'rxjs'
import { SALARIES_SUMMARY_API_URL } from './admin-api-routes'
import { ISalariesDetailResponse } from '../interfaces/salaries-detail.interface'
import { ISalariesSummaryRequest } from '../interfaces/salaries-summary.interface'

@Injectable({
  providedIn: 'root'
})
export class SalariesDetailService {
  constructor(
    private http: HttpService,
    private dateService: DateService
  ) {}

  getSalariesDetail(payload: ISalariesSummaryRequest): Observable<ISalariesDetailResponse> {
    const { from, to } = payload
    return this.http.post(SALARIES_SUMMARY_API_URL.detail, {
      ...payload,
      from: this.dateService.momentToDateString(from),
      to: this.dateService.momentToDateString(to)
    })
  }
}
